import { render, staticRenderFns, recyclableRender, components } from "./list.vue?vue&type=template&id=228722bd&scoped=true&"
var renderjs
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=228722bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228722bd",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/personalCenter/activity/list.vue"
export default component.exports